export const columns = [
  {
    title: "N",
    dataIndex: "id",
    key: "id",
    defaultFlex: 0.5,
  },
  {
    title: "Դասարան",
    dataIndex: "school",
    key: "school",
    defaultFlex: 0.7,
  },
  {
    title: "Առարկան՝ ըստ պետական պարտադիր առարկայացանկի",
    dataIndex: "subjects",
    key: "subjects",
    defaultFlex: 1,
  },
  {
    title: "ուսումնական առարկայի պարտադիր նվազագույն ժամաքանակ",
    dataIndex: "hours",
    key: "hours",
    defaultFlex: 1,
  },
  {
    title:
      "ուսումնական առարկային դպրոցական բաղադրիչից հատկացվող ցանկալի ժամաքանակ",
    dataIndex: "schoolHours",
    key: "schoolHours",
    defaultFlex: 1,
  },
  {
    title:
      "ուսումնական առարկային անհատական բաղադրիչից հատկացվող ցանկալի ժամաքանակ",
    dataIndex: "individualHours",
    key: "individualHours",
    defaultFlex: 1,
  },
];

export const rows = [
  {
    id: 1,
    school: "1֊ին",
    subjects: ["Մայրենի"],
    hours: [7],
    schoolHours: [3],
    individualHours: [1],
  },
  {
    id: 2,
    school: "2֊րդ",
    subjects: ["Մայրենի", "Ես և շրջակա աշխարհը"],
    hours: [7, 1],
    schoolHours: [2, 1],
    individualHours: [1, 1],
  },
  {
    id: 3,
    school: "3֊րդ",
    subjects: ["Մայրենի", "Ես և շրջակա աշխարհը"],
    hours: [7, 1],
    schoolHours: [1, 1],
    individualHours: [1, 1],
  },
  {
    id: 4,
    school: "4֊րդ",
    subjects: ["Մայրենի", "Ես և շրջակա աշխարհը"],
    hours: [7, 2],
    schoolHours: [1, 1],
    individualHours: [1, 1],
  },
];
